import { render, staticRenderFns } from "./StatusLote.vue?vue&type=template&id=ef246fd0&"
import script from "./StatusLote.vue?vue&type=script&lang=js&"
export * from "./StatusLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports